import React from 'react';
import { useNavigate } from 'react-router-dom';
import './Home.css';

const Home: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div className="home-container">
      <div className="home-content">
        <div className="brand-circles-wrapper">
          <img 
            src="/images/dmb-homepage.png" 
            alt="DMB Brands" 
            className="home-image"
          />
          <div 
            className="catalogues-circle"
            onClick={() => navigate('/catalogues')}
          >
            <span className="catalogues-text">Catalogues</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Home;